/**
 * Get the next day's midnight date in order to display date correctly from
 * UTC to local timezone and return the date in MonthName DD, YYYY format
 * @param  {String} dateUTC The date returned in UTC format from the API
 * @return {String}         The date specified in MonthName DD, YYYY format
 */
export function getAwardDateFormatted(dateString, format = 'long') {
  return formatDate(getNextMidnight(dateString), format)
}

/**
 * Formats a date into a human-readable string
 * @param  {Date} date   A Date object
 * @return {String}      That Date formatted
 */
function formatDate(date, format) {
  if (format === 'long') {
    const month = date.toLocaleString('default', { month: 'long' })
    return `${month} ${date.getDate()}, ${date.getFullYear()}`
  } else if (format === 'short') {
    const month = date.toLocaleString('default', { month: 'short' })
    return `${month} ${date.getDate()}`
  }
}

/**
 * Get the nearest midnight in future.
 * When getting the start of the next award period,
 * the server returns the start date in the server's tiem zone.
 * This conversion finds the next closest midnight to a given time.
 * i.e. The server says the award period begins at Midnight, Jan 1,
 *      A client in Denver gets that date as a string,
 *      but after creating a new JS Date object,
 *      the resulting Date is now 10pm Dec 31
 * @param  {String} dateString A string that can be used to create new Date
 * @return {Date}              A Date object set to the closest midnight to dateString
 */
function getNextMidnight(dateString) {
  const dateLocal = new Date(dateString).setHours(24,0,0,0)
  return new Date(dateLocal)
}
